import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Iconify from './Iconify';
import { usePermissaoNotificacao } from 'src/hooks/useNotificacoes';

const CHAVE_SONECA = 'lais_notif_banner_snooze';
const SONECA_MS = 24 * 60 * 60 * 1000;

const estaEmSoneca = () => {
  try {
    const ate = Number(localStorage.getItem(CHAVE_SONECA));
    return Number.isFinite(ate) && ate > Date.now();
  } catch {
    return false;
  }
};

export default function NotificationPermissionBanner() {
  const { t } = useTranslation('notifications');
  const { estado, perdeuNotificacao, pedir } = usePermissaoNotificacao();
  const [dispensado, setDispensado] = useState(estaEmSoneca);

  // Se o painel ja perdeu uma notificacao de verdade, a soneca deixa de valer:
  // o usuario precisa saber que esta cego para mensagens novas.
  useEffect(() => {
    if (perdeuNotificacao) setDispensado(false);
  }, [perdeuNotificacao]);

  if (estado === 'granted' || estado === 'unsupported') return null;
  if (dispensado) return null;

  const negado = estado === 'denied';

  const dispensar = () => {
    try {
      localStorage.setItem(CHAVE_SONECA, String(Date.now() + SONECA_MS));
    } catch {
      // Sem localStorage o banner volta no proximo load; aceitavel.
    }
    setDispensado(true);
  };

  return (
    // O posicionamento fixo saiu daqui: quem posiciona é a coluna de canto do
    // NotificationGate, que empilha este banner junto com os avisos pendentes.
    <div
      role="alert"
      className="w-[360px] max-w-[calc(100vw-2rem)] bg-white rounded-xl border border-gray-100 shadow-lg p-4 flex items-start gap-3 animate-in fade-in slide-in-from-bottom-4 duration-500 motion-reduce:animate-none"
    >
      <div
        className={`w-10 h-10 rounded-xl flex items-center justify-center shrink-0 ${
          negado ? 'bg-amber-50' : 'bg-violet-50'
        }`}
      >
        <Iconify
          icon={negado ? 'eva:bell-off-outline' : 'eva:bell-outline'}
          width={20}
          className={negado ? 'text-amber-600' : 'text-violet-600'}
        />
      </div>

      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-gray-900">
          {negado ? t('permissao.tituloBloqueado') : t('permissao.titulo')}
        </p>
        <p className="text-xs text-gray-500 mt-0.5 leading-relaxed">
          {negado ? t('permissao.instrucaoBloqueado') : t('permissao.descricao')}
        </p>

        {!negado && (
          <button
            type="button"
            onClick={pedir}
            className="mt-3 flex items-center gap-2 px-4 py-2.5 bg-[#7C3AED] hover:bg-[#6d28d9] text-white text-sm font-medium rounded-xl transition-all shadow-sm shadow-[#7C3AED]/20 active:transform active:scale-95"
          >
            <Iconify icon="eva:bell-outline" width={16} />
            {t('permissao.ativar')}
          </button>
        )}
      </div>

      <button
        type="button"
        onClick={dispensar}
        aria-label={t('permissao.fechar')}
        className="text-gray-400 hover:text-gray-600 transition-colors shrink-0"
      >
        <Iconify icon="eva:close-outline" width={16} />
      </button>
    </div>
  );
}
